import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token:'',
    accountId:'',
    uniqueId:'',
    actInfo:{},
    actExtend:{}
  },  
  mutations: {    

    SET_TOKEN(state, token) {
      state.token = token;
    },
    SET_ACCOUNTID(state, accountId) {
      state.accountId = accountId;
    },
    SET_UNIQUEID(state, uniqueId) {
      state.uniqueId = uniqueId;
    },
    SET_ACTINFO(state, actInfo) {
      state.actInfo = actInfo;
    },
  },
  actions: {
  },
  modules: {
  },
  getters: {
  }
})
